import Typography from "@material-ui/core/Typography";

const carrierEmailProvidersList = {
	urlGET: "api/profile/carriers/:carrierId/email-providers",
	idKey: "_id",
	listenEvent: "profileRevision",
	segmentKey: "PROFILE_EMAIL_PROVIDERS",
	content: {
		grid: {
			tilesPerRow: 2,
			itemsPerRow: 1,
			mobile: {
				tilesPerRow: 1,
				itemsPerRow: 2,
				layout: [["provider", "username"]],
			},
		},
		table: {
			variant: "skinny",
			theme: "dark",
		},
		items: [
			{
				key: "_id",
				label: "Provider",
				table: { align: "left" },
				builder: (item) => {
					if (item.provider === "office365") {
						return <Typography className="text-13 max-w-180 truncate">Office 365</Typography>;
					} else if (item.provider === "gmail") {
						return <Typography className="text-13 max-w-180 truncate">Gmail</Typography>;
					} else {
						return <Typography className="text-13 max-w-180 truncate">{item.server_name || "SMTP"}</Typography>;
					}
				},
			},
			{
				key: "username",
				label: "Email",
				table: { align: "left" },
				builder: (item) => {
					return <Typography className="text-13 max-w-180 truncate">{item.authentication?.username || "-"}</Typography>;
				},
			},
			{
				key: "enabled",
				type: "text",
				label: "Status",
				table: { width: "17%" },
				builder: (item) => {
					if (item.enabled) {
						return <Typography className="text-13 max-w-180 truncate">Enabled</Typography>;
					} else {
						return <Typography className="text-13 max-w-180 truncate text-grey">Disabled</Typography>;
					}
				},
			},
			{
				key: "menu",
				type: "menu",
				label: "",
				items: [
					{
						key: "view",
						label: "View",
						dialogBuilder: (item, dataIds) => ({
							formId: "CARRIER_EMAIL_PROVIDER_FORM",
							mode: "VIEW",
							dataIds: { providerId: item._id, carrierId: dataIds.carrierId },
						}),
					},
					{
						key: "edit",
						label: "Edit",
						dialogBuilder: (item, dataIds) => ({
							formId: "CARRIER_EMAIL_PROVIDER_FORM",
							mode: "EDIT",
							dataIds: { providerId: item._id, carrierId: dataIds.carrierId },
						}),
					},
					{
						key: "delete",
						label: "Delete",
						dialogBuilder: (item, dataIds) => ({
							formId: "CARRIER_EMAIL_PROVIDER_FORM",
							mode: "DELETE",
							dataIds: { providerId: item._id, carrierId: dataIds.carrierId },
						}),
					},
					/*{
						key: "toggleStatus",
						label: (item) => (item.enabled ? "Disable" : "Enable"),
						dialogBuilder: (item, dataIds) => ({
							formId: "CARRIER_EMAIL_PROVIDER_FORM",
							mode: "TOGGLE",
							dataIds: { providerId: item._id, carrierId: dataIds.carrierId },
						}),
					},*/
				],
			},
		],
	},
};

export default carrierEmailProvidersList;
